import script from "./TgMenu.vue?vue&type=script&lang=ts&setup=true"
export * from "./TgMenu.vue?vue&type=script&lang=ts&setup=true"

import "./TgMenu.vue?vue&type=style&index=0&id=5a017cc2&lang=css"

const __exports__ = script;

export default __exports__